// extracted by mini-css-extract-plugin
export default {"statics":"Statics_statics__-u5BK"};